import React, { useRef } from 'react';
import { Check } from 'lucide-react';
import { SIMPLISTIC_THEMES, useSimplisticTheme } from './SimplisticThemeContext';
import './SimplisticThemePicker.css';

export default function SimplisticThemePicker() {
  const { theme, setTheme } = useSimplisticTheme();
  const choices = useRef([]);
  const handleKey = (event, index) => {
    let next;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % SIMPLISTIC_THEMES.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + SIMPLISTIC_THEMES.length - 1) % SIMPLISTIC_THEMES.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = SIMPLISTIC_THEMES.length - 1;
    else return;
    event.preventDefault();
    setTheme(SIMPLISTIC_THEMES[next].id);
    choices.current[next]?.focus();
  };
  return <>
    <p className="simple-theme-intro">Choose a colour palette. Your buylist stays just as you left it.</p>
    <div className="simple-theme-grid" role="radiogroup" aria-label="Colour theme">
      {SIMPLISTIC_THEMES.map((option, index) => <button
        key={option.id} ref={node => { choices.current[index] = node; }} type="button"
        className="simple-theme-option" role="radio" aria-checked={theme === option.id}
        tabIndex={theme === option.id ? 0 : -1} onClick={() => setTheme(option.id)} onKeyDown={event => handleKey(event, index)}>
        <span className="simple-theme-swatch" style={{ background: `linear-gradient(135deg, ${option.colours[0]} 50%, ${option.colours[1]} 50%)` }} aria-hidden="true" />
        <span>{option.name}</span>
        {theme === option.id && <Check className="simple-theme-check" size={15} aria-hidden="true" />}
      </button>)}
    </div>
    <p className="simple-theme-persistence" role="status">{SIMPLISTIC_THEMES.find(option => option.id === theme)?.name} selected · Saved for this store in your browser</p>
  </>;
}
